import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import { ApiService } from './api.service';
@Injectable({
  providedIn: 'root'
})
export class ChatgptService {

  private apiURL = 'https://api.openai.com/v1/chat/completions';
  public apiKey = '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';
  private noraGPTURL = 'http://openai.noratech.it/';


  constructor(public apiService: ApiService, private http: HttpClient) { }


  public getResponse(promptText: string, chatFiles: any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    let data: any;
    if (chatFiles.url_documentazione.length > 0){
      data = {
        message: promptText,
        openai_api_key: this.apiKey,
        url_documentazione: chatFiles.url_documentazione
      };
    }else{
      data = {
        message: promptText,
        openai_api_key: this.apiKey
      };
    }

    return this.http.post(this.noraGPTURL + 'arxchat', data, httpOptions);
  }
  public updateSettings(jsonData: string): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };


    return this.http.post(this.noraGPTURL + 'config_ai', jsonData, httpOptions);
  }
  public getSettings(): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    const data = {
      openai_api_key: this.apiKey
    };

    return this.http.post(this.noraGPTURL + 'getOpenAiData', data, httpOptions);
  }

  public getResponseCHATGPT(promptText: string): any {
    const data = {
      model: 'gpt-3.5-turbo',
      messages: [{role: 'user', content: promptText}]
    };
    return this.http.post(this.apiURL, data, {
      headers: {
        Authorization: `Bearer ` + this.apiKey
      }
    });
  }
}


